<template>
  <FlashElement :isBlocked="selectedId !== id" class="option-radio">
    <Radio
      :hasRadioButtonHidden="true"
      :value="id"
      :model="selectedId"
      :name="name"
      :isDisabled="isDisabled"
      v-bind="$attrs"
      v-on="$listeners"
      @update:model="$emit('update:selectedId', $event)"
    >
      <div
        class="option-radio__wrapper"
        :class="{
          'option-radio__wrapper--selected': isSelected,
          'option-radio__wrapper--loading': isLoading,
          'option-radio__wrapper--disabled': isDisabled,
        }"
      >
        <slot />
      </div>
    </Radio>
  </FlashElement>
</template>

<script>
import FlashElement from '@/components/_shared/FlashElement.vue'
import Radio from '@/components/_shared/Form/Radio/Radio.vue'

export default {
  name: 'OptionRadio',
  components: {
    FlashElement,
    Radio,
  },

  // bind attributes to input (not to rool el) using v-bind="$attrs"
  inheritAttrs: false,

  props: {
    id: {
      type: String,
      required: true,
    },
    selectedId: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    isSelected() {
      return this.id === this.selectedId
    },
  },
}
</script>

<style lang="scss" scoped>
$circle-size: 16px;

@mixin loading-state($color) {
  @include spinner($circle-size, $color, 1px);
  position: static;
  top: auto;
  left: auto;
}

.option-radio {
  width: 100%;
  border: 1px solid $color-grey-light-5;
  border-top: none;

  &:first-child {
    border-top: 1px solid $color-grey-light-5;
    border-top-left-radius: 2px;
    border-top-right-radius: 2px;
  }

  &:last-child {
    border-bottom-left-radius: 2px;
    border-bottom-right-radius: 2px;
  }

  &__wrapper {
    display: flex;
    align-items: flex-start;
    margin: 0;
    padding: 14px 16px 16px;
    cursor: pointer;

    &:before {
      display: block;
      content: '';
      width: $circle-size;
      height: $circle-size;
      margin: 2px 20px 0 0;
      background: $color-white;
      border: 1px solid $color-grey-mid-1;
      border-radius: 100%;
      flex: none;
    }

    &:hover:before {
      border-color: $color-grey-mid-2;
    }

    &--disabled {
      cursor: default;

      &:hover:before {
        border: 1px solid $color-grey-mid-1;
      }
    }

    &--selected {
      &:hover:before,
      &:before {
        border: 5px solid $color-green-dark;
      }
    }

    &--loading {
      &:hover:before,
      &:before {
        @include loading-state($color-grey-mid-1);
      }
    }

    &--selected#{&}--loading {
      &:hover:before,
      &:before {
        @include loading-state($color-green-dark);
      }
    }
  }
}
</style>
